import { getData, postData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

const token = localStorage.getItem("token");
const userInfo = JSON.parse(localStorage.getItem("userInfo"));


//function for get all tags
export const getAutomationOptionsByName = async (query = "") => {

    try {
        let requestUrl =
        url.API_BASE_URL +
        url.API_AUTOMATION_LIST_SELECT +
        `?token=${token}&filterlabelname=${query}`;

        const response = await getData(requestUrl);

        console.log("response all automation", response);

        if (response.status) {
            const records = response.data.map((record) => ({
                value: record._id,
                label: record.name,
            }));

            return records;
        }
    } catch (error) {
        console.log(error.message);
        return [];
    }
};

//function to get all automation task schedule templates
export const getAutomationTaskScheduleTemplates = async (query = "") => {
    try {
        let requestUrl =
            url.API_BASE_URL +
            url.API_GET_AUTOMATION_TASK_SCHEDULE_TEMPLATES +
            `?token=${token}&filterlabelname=${query}`;

        const response = await getData(requestUrl);

        console.log("response all templates", response);

        if (response.status) {
            const templates = response.data.map((template) => ({
                value: template._id || template.id,
                label: template.name,
            }));

            return templates;
        }
    } catch (error) {
        console.log(error.message);
        return [];
    }
};